"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Path", {
  enumerable: true,
  get: function () {
    return _path.Path;
  }
});
Object.defineProperty(exports, "path", {
  enumerable: true,
  get: function () {
    return _path.path;
  }
});
Object.defineProperty(exports, "pathRound", {
  enumerable: true,
  get: function () {
    return _path.pathRound;
  }
});
var _path = require("./path.js");